import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return data.map(i => ({
      ...i,
      status_name: i.tx_status_name?.[0]?.name,
    }))
  }, [data])
}
